export const CHAR_WIDTH = 12
export const ROW_HEIGHT = 16
export const FONT = 'bold 12px monospace'
export const LABEL_PADDING = 10
